export const products = [
  { 
    id: 1, 
    name: "Car Insurance (Comprehensive)", 
    type: "car",
    icon: "🚗",
    description: "Full coverage for your car including theft, damage, and third-party liability."
  },
  { 
    id: 2, 
    name: "Motor Cycle Insurance (Comprehensive)", 
    type: "bike",
    icon: "🏍️",
    description: "Complete protection for your motorcycle against accidents, theft, and other risks."
  },

    { 
  id: 3, 
  name: "Act Liability (Third Party) Insurance", 
  type: "tp",
  icon: "📜🚗🚚🏍️🚧", 
  description: "Legal coverage for  vehicles to protect against third-party bodily injury and property damage."
},


  { 
    id: 4, 
    name: "Commercial Vehicle Insurance", 
    type: "al",
    icon: "🚚🏍️🛺🚗",
    description: "Full coverage for commercial vehicles including against incidents."
  },

 

    {
  id: 5,
  name: "Overseas Mediclaim Insurance (OMP)/ Travel Insurance",
  type: "overseas_mediclaim",
  icon: "🩺✈️",
  description: "Comprehensive medical coverage abroad including hospitalization, emergency treatment, and medical evacuation."
},
  /* {
    id: 5 ,
    name: "Flat / Apartment Owner Insurance",
    type: "property",
    icon: "🏢",
    description: "Protect your home and belongings with comprehensive coverage:This insurance safeguards your apartment or flat against a wide range of risks."
  }
  */



];
